import { EuiSpacer } from '@elastic/eui';
import VideoCard from 'components/Internet_Access/Videos/video-port-forwarding-speedport';
import NavButtons from 'components/Internet_Access/Port_Forwarding/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  VideoCard,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};